// src/pages/ActivationSuccessPage.jsx
import React, { useEffect, useState, useContext } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import { LikesContext } from '../context/LikesContext';
import { TabContext } from '../context/TabContext';

export default function ActivationSuccessPage() {
  const [searchParams]     = useSearchParams();
  const { login }          = useContext(AuthContext);
  const { loadFavorites }  = useContext(LikesContext);
  const { setActiveTab }   = useContext(TabContext);
  const navigate           = useNavigate();
  const [status, setStatus] = useState('pending'); // 'pending' | 'success' | 'error'

  // 👉 Logs de entorno y URL actual
  console.log('[ActivationSuccessPage] process.env.REACT_APP_BACKEND_ORIGIN:', process.env.REACT_APP_BACKEND_ORIGIN);
  console.log('[ActivationSuccessPage] process.env.REACT_APP_FRONTEND_ORIGIN:', process.env.REACT_APP_FRONTEND_ORIGIN);
  console.log('[ActivationSuccessPage] window.location.href:', window.location.href);

  // 1️⃣ Efecto: parseo de params + login + cargar favoritos + poner pestaña
  useEffect(() => {
    const entries = Array.from(searchParams.entries());
    console.log('[ActivationSuccessPage] params:', entries);

    const access   = searchParams.get('access');
    const refresh  = searchParams.get('refresh');
    const uid      = searchParams.get('id');
    const username = searchParams.get('username');
    const email    = searchParams.get('email');
    const isPro    = searchParams.get('is_professional') === 'True';

    console.log('[ActivationSuccessPage] access, refresh, id:', access, refresh, uid);

    if (!access || !refresh || !uid) {
      console.error('[ActivationSuccessPage] falta algún parámetro');
      setStatus('error');
      return;
    }

    // 1️⃣ Guardar tokens
    localStorage.setItem('accessToken', access);
    localStorage.setItem('refreshToken', refresh);

    // 2️⃣ Login en contexto
    login(access, { id: uid, username, email, is_professional: isPro });

    // 3️⃣ Cargar favoritos del usuario
    loadFavorites().catch(err => {
      console.error('[ActivationSuccessPage] Error cargando favoritos:', err);
    });

    // 4️⃣ Forzar pestaña "home"
    setActiveTab('home');

    // 5️⃣ Finalmente marcamos éxito
    setStatus('success');
  }, [searchParams, login, loadFavorites, setActiveTab]);

  // 2️⃣ Efecto: redirección tras éxito
  useEffect(() => {
    if (status === 'success') {
      const timeoutId = setTimeout(() => {
        navigate('/');
      }, 5000);
      return () => clearTimeout(timeoutId);
    }
  }, [status, navigate]);

  if (status === 'pending') {
    return (
      <div style={{ paddingTop: '60px', textAlign: 'center' }}>
        <p>⏳ Activando tu cuenta, por favor espera…</p>
      </div>
    );
  }

  if (status === 'error') {
    return (
      <div style={{ paddingTop: '60px', textAlign: 'center' }}>
        <h2>❌ No se pudo activar la cuenta</h2>
        <p>El enlace no es válido o ya expiró.</p>
        <a href="/" className="btn">Volver al inicio</a>
      </div>
    );
  }

  // status === 'success'
  return (
    <div style={{ paddingTop: '60px', textAlign: 'center' }}>
      <h2>✅ ¡Cuenta activada!</h2>
      <p>Tu cuenta ha sido activada correctamente.</p>
      <p>Redirigiendo al inicio en unos segundos...</p>
      <a href="/" className="btn">Ir al inicio ahora</a>
    </div>
  );
}
